<template>
  <div>
    <v-container
      v-if="searchImageGoodsList.length"
      class="pt-0"
    >
      <div class="text-h3 mt-8 font-medium text-uppercase">
        <template v-if="$store.getters.languageGetter === '1'">
          منتجات مماثلة
        </template>
        <template v-else>
          Similar Products
        </template>
      </div>
      <v-row
        class="text-center"
      >
        <v-col
          v-for="item in searchImageGoodsList"
          :key="item.id"
          :cols="$store.state.mobile ? 6 : 2"
        >
          <div
            class="py-3"
          >
            <v-card
              elevation="0"
              tile
            >
              <router-link
                :to="{name: 'GoodsDetail', params: {id: item.id}}"
              >
                <v-img
                  aspect-ratio="1"
                  contain
                  :src="item.image + '?x-oss-process=image/resize,m_mfit,w_375,h_375'"
                  class="grey lighten-5"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey"
                      />
                    </v-row>
                  </template>
                </v-img>
              </router-link>
            </v-card>
            <div class="px-4">
              <div class="text-h6 mt-2 line-break line-height-sm">
                <router-link
                  :to="{name: 'GoodsDetail', params: {id: item.id}}"
                >
                  {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
                </router-link>
              </div>
              <div
                v-if="$store.state.usedCountry"
                class="black--text d-flex align-center justify-center"
              >
                <span
                  class="text-h4 me-2"
                >{{ $store.getters.countryGetter.currency }}{{ (priceRate(item) * +$store.getters.rebateGetter / 100).toFixed(2) }}</span>
                <span :class="$store.getters.rebateGetter < 100 ? 'text-decoration-line-through grey--text' : 'd-none'">{{ $store.getters.countryGetter.currency }}{{ priceRate(item).toFixed(2) }}</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div
      v-else
      class="grey--text py-4 text-center"
    >
      <template v-if="$store.getters.languageGetter === '1'">
        لا يوجد شيء هنا
      </template>
      <template v-else>
        There is nothing here
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SearchImgGoodsList',
  components: {
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['searchImageGoodsList']),
  },
  methods: {
    priceRate(item) {
      return (+item.countryPrice[this.$store.getters.countryGetter.id] * +this.$store.getters.countryGetter.rate);
    },
  },
};
</script>

<style lang="scss">

</style>
